<template>
  <div
    v-if="items && selected"
    name="version-dropdown"
    class="dropdown"
    :class="{ 'is-active': show }"
  >
    <div class="dropdown-trigger">
      <a
        class="button is-small smaller no-border"
        :class="{
          'is-loading': loading,
          'has-text-warning': !selected.chocoPackage.IsLatestVersion,
        }"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click.stop="getPackageVersions(selected, nameAndVersion(selected))"
      >
        <span>{{ nameAndVersion(selected).version }}</span>
        <span class="icon is-small">
          <i class="mdi mdi-chevron-down" aria-hidden="true"></i>
        </span>
      </a>
    </div>

    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          class="dropdown-item is-small"
          v-for="(otherVersionItem, $index) of visible"
          :key="$index"
          @click="getPackage(selected, otherVersionItem)"
        >
          <span
            v-if="
              otherVersionItem.groupInfo &&
                otherVersionItem &&
                otherVersionItem.groupInfo.autoGroup &&
                otherVersionItem.groupInfo.isAutoUpgrade
            "
            class="icon tooltip"
            :data-tooltip="
              otherVersionItem.groupInfo &&
                otherVersionItem.groupInfo.autoGroup.name
            "
          >
            <i class="mdi mdi-account-group"></i>
          </span>
          <span
            v-if="
              otherVersionItem.groupInfo &&
                otherVersionItem.groupInfo.group &&
                !otherVersionItem.groupInfo.isAutoUpgrade
            "
            class="icon tooltip"
            :data-tooltip="otherVersionItem.groupInfo.name"
          >
            <i class="mdi mdi-account-group"></i>
          </span>
          <span
            v-if="
              otherVersionItem &&
                otherVersionItem.groupInfo &&
                otherVersionItem.groupInfo.isAutoUpgrade
            "
            class="icon tooltip"
            data-tooltip="Auto upgrade"
          >
            <i class="mdi mdi-cached"></i>
          </span>
          <span>{{ otherVersionItem.chocoPackage.Version }}</span>

          <span
            v-if="
              !isGroup &&
                ((otherVersionItem.command &&
                  otherVersionItem.command.status === 'done' &&
                  otherVersionItem.command.name === 'install') ||
                  (otherVersionItem.command.status === 'done' &&
                    otherVersionItem.command.name === 'upgrade'))
            "
            class="icon tooltip"
            data-tooltip="Install/upgrade done"
          >
            <i class="mdi mdi-check"></i>
          </span>
          <span
            v-if="
              (otherVersionItem.command &&
                otherVersionItem.command.status === 'done' &&
                otherVersionItem.command.name === 'uninstall') ||
                (isGroup && otherVersionItem.command.name === 'uninstall')
            "
            class="icon tooltip"
            data-tooltip="Uninstall done"
          >
            <i class="mdi mdi-delete"></i>
          </span>
          <span
            v-if="
              !isGroup &&
                otherVersionItem.command &&
                otherVersionItem.command.status === 'pending'
            "
            class="icon"
          >
            <i class="mdi mdi-clock"></i>
          </span>

          <span
            v-if="
              isGroup &&
                ((otherVersionItem.command &&
                  otherVersionItem.command.name === 'install') ||
                  (otherVersionItem.command &&
                    otherVersionItem.command.name === 'upgrade'))
            "
            class="icon tooltip"
            data-tooltip="Install/upgrade"
          >
            <i class="mdi mdi-check"></i>
          </span>

          <span
            v-if="
              otherVersionItem.command &&
                otherVersionItem.command.status == 'working'
            "
            class="icon tooltip"
            data-tooltip="In progress"
          >
            <i class="mdi mdi-timer-sand-full"></i>
          </span>
          <span
            v-if="
              otherVersionItem.command &&
                otherVersionItem.command.status == 'failed'
            "
            class="icon tooltip"
            data-tooltip="Action failed"
          >
            <i class="mdi mdi-information has-text-danger"></i>
          </span>

          <span
            v-if="hasParam(otherVersionItem, '-n')"
            class="icon tooltip"
            data-tooltip="Add/remove package only"
            >-n</span
          >

          <span
            v-if="hasParam(otherVersionItem, '-f')"
            class="icon tooltip"
            data-tooltip="Forced"
            >-f</span
          >

          <span
            v-if="hasParam(otherVersionItem, '-m')"
            class="icon tooltip"
            data-tooltip="Allows multiple versions of a package"
            >-m</span
          >
          <span
            v-if="isGroup && hasValidSchedule(otherVersionItem)"
            class="icon"
            data-tooltip="Scheduled"
          >
            <i class="mdi mdi-calendar-month"></i>
          </span>

          <span
            v-if="isGroup && isAutoUpgrade(otherVersionItem)"
            class="icon"
            data-tooltip="Auto upgrade"
          >
            <i class="mdi mdi-cached"></i>
          </span>
        </a>
        <a
          class="dropdown-item has-text-centered has-text-link margin-top-5 is-unselectable"
          ignore="true"
          :disabled="loading"
          @click.stop="
            getPackageVersions(selected, nameAndVersion(selected), true)
          "
        >
          {{ !loading ? "More" : "" }}
          <span
            v-if="selected"
            class="margin-left"
            :class="{
              'spinner small margin': loading,
            }"
          ></span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { hasParam, toIsoDate, getPackageNameVersionAndHash } from "@/utils/mdc";
import { isScheduleValid, objectifySchedule } from "@/utils/packageDate";

import {
  getAllPackageVersions,
  getAllMdcVersionsFn,
  getAllMdcVersions,
} from "@/utils/packages";

import { fetchPackagesStats } from "@/utils/groupPackage";

export default {
  props: { items: Array, isGroup: Boolean },

  computed: {
    selected() {
      return this.items.find((x) => x.selected);
    },

    hasValidSchedule() {
      return (item) => {
        return isScheduleValid(objectifySchedule(item.schedule));
      };
    },
    hasAutoUpgrade() {
      return (items) => {
        return items.some(
          (x) =>
            isScheduleValid(objectifySchedule(x.schedule)) &&
            x.schedule.type === 1
        );
      };
    },

    isAutoUpgrade() {
      return (item) => {
        return (
          isScheduleValid(objectifySchedule(item.schedule)) &&
          item.schedule.type === 1
        );
      };
    },

    icon() {
      return (item) => {
        return item.chocoPackage.IconUrl
          ? item.chocoPackage.IconUrl
          : "/box.png";
      };
    },
    hasParam() {
      return (item, param) => {
        return item.command && hasParam(item.command.parameters, param);
      };
    },

    toIso() {
      return (date) => {
        return toIsoDate(date);
      };
    },
    nameAndVersion() {
      return (item) => {
        return getPackageNameVersionAndHash(item);
      };
    },
    visible() {
      return this.items.filter((x) => x.visible);
    },
  },

  data() {
    return {
      show: false,
      loading: false,
      store: null,
      getPackagesFn: null,
    };
  },
  created() {
    if (this.isGroup) this.store = "groupPackage";
    else this.store = "computerPackage";
  },
  methods: {
    async getPackage(item, otherVersionItem) {
      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: item,
        obj: { selected: false },
      });

      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: otherVersionItem,
        obj: { selected: true },
      });

      if (this.isGroup) {
        this.getGroupStats(otherVersionItem);
      }

      this.show = false;
      this.$emit("change", otherVersionItem);
    },
    async getPackageVersions(selected, nameAndVersion, force) {
      const { name, uid } = nameAndVersion;
      const shouldReload = !this.$store.state[this.store].fullyLoadedPackages[
        name + uid
      ];

      if (
        force ||
        this.$store.state[this.store].mergedPackages[name + uid].filter(
          (x) => x.visible || x.selected
        ).length <= 1
      ) {
        this.loading = true;

        let mdcPackages = null;

        if (shouldReload) {
          mdcPackages = await getAllMdcVersions(
            selected,
            this.store,
            getAllMdcVersionsFn(selected, this.isGroup, this.$route.params)
          );
        }

        const result = await getAllPackageVersions(
          mdcPackages ||
            this.$store.state[this.store].mergedPackages[name + uid],
          { ...selected }
        );

        this.$store.commit(`${this.store}/setMergedPackageVersions`, result);
      }

      this.showVersions();
      this.loading = false;
    },
    showVersions() {
      this.show = true;
      document.addEventListener("click", this.hideVersions);
    },
    hideVersions() {
      this.show = false;
      document.removeEventListener("click", this.hideVersions);
    },
    async getGroupStats(item) {
      await this.$store.dispatch(
        "group/fetch",
        { domainUID: this.$route.params.domainUID },
        { root: true }
      );

      const group = this.$store.getters["group/single"](
        this.$route.params.groupUID
      );

      await fetchPackagesStats(
        [item],
        group,
        this.$route.params.domainUID,
        true
      );
    },
  },
};
</script>
